import React from 'react';

/**
 * Defers rendering of a loading placeholder until `delayMs` has elapsed.
 *
 * This avoids the visual "flicker" where a skeleton appears and disappears
 * almost instantly on fast API responses. The skeleton is only shown when a
 * request is actually slow enough for the user to notice the wait.
 */
export function useDelayedVisible(delayMs = 250): boolean {
  const [visible, setVisible] = React.useState(delayMs <= 0);

  React.useEffect(() => {
    if (delayMs <= 0) {
      setVisible(true);
      return;
    }
    const id = window.setTimeout(() => setVisible(true), delayMs);
    return () => window.clearTimeout(id);
  }, [delayMs]);

  return visible;
}
